/* eslint-disable @typescript-eslint/no-explicit-any */
import { isAxiosError } from 'axios';
import { acalarmTypes } from '../acReduxExports';

import { isEqual } from 'lodash';
import hwAxios from '../../../rmsReduxStore/api-service/HWAxios';
import rmsStore from '../../../rmsReduxStore/rmsStore';
import { getAcFilterSelectedValue, setAcFilterData } from '../acFiltersRedux/acFiltersCreators';
import { fetchAlarmTypeReferenceData, fetchCustomerReferenceData } from '../../../rmsReduxStore/reduxExports';
import { fetchAlarmRuleSeverityReferenceData, fetchChargerStatusReferenceData, fetchChargerVisibleIdReferenceData } from '../../../rmsReduxStore/referenceDataRedux/referenceDataCreators';

const url = process.env.REACT_APP_SERVER_BASE_URL_AC;

export const fetchAcAlarmListData: any =
  (reqParams) =>
    async (dispatch): Promise<void> => {
      try {
        const loaderStartAction: Partial<AcAlarmsAction> = {
          type: acalarmTypes.SET_PULSE_AC_ALARM_LIST_LOADER,
          alarmTableListLoader: true
        }
        dispatch(loaderStartAction);
        const searchHash = reqParams?.searchTerm
        const filterHash = reqParams?.filters
        const hashAction: Partial<AcAlarmsAction> = {
          type: acalarmTypes.SET_AC_ALARM_LIST_REQUEST_HASH,
          alarmListRequestSearchHash: searchHash,
          alarmListRequestFilterHash: filterHash
        }
        await dispatch(hashAction)
      const response = await hwAxios.post( url +'/alarm/alarm-list', reqParams);

          const action = {
            type: acalarmTypes.FETCH_AC_ALARM_DATA,
            alarms: response.data?.data?.alarms,
            alarmsCount: response.data?.data?.alarmsCount,
          };
          dispatch(action);

        if (response?.status === 200) {
          const loaderEndAction: Partial<AcAlarmsAction> = {
            type: acalarmTypes.SET_PULSE_AC_ALARM_LIST_LOADER,
            alarmTableListLoader: false
          }
          dispatch(loaderEndAction);
        }
      } catch (error) {
        const loaderEndAction: Partial<AcAlarmsAction> = {
          type: acalarmTypes.SET_PULSE_AC_ALARM_LIST_LOADER,
          alarmTableListLoader: false
        }
        dispatch(loaderEndAction);
        console.error(error);
        throw error;
      }
    };

export const fetchAcAlarmCardCountData: any = (reqParams) => async (dispatch): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcAlarmsAction> = {
      type: acalarmTypes.SET_PULSE_AC_ALARM_LOADER,
      pulseAlarmLoader: true
    }
    dispatch(loaderStartAction);
    const searchHash = reqParams?.searchTerm
    const filterHash = reqParams?.filters
    const hashAction: Partial<AcAlarmsAction> = {
      type: acalarmTypes.SET_AC_ALARM_LIST_CARDS_REQUEST_HASH,
      alarmListCardsRequestSearchHash: searchHash,
      alarmListCardsRequestFilterHash: filterHash
    }
    await dispatch(hashAction)

    const response = await hwAxios.post(url +'/alarm/alarm-list/count', reqParams);
    // const response = {
		// 	data: {
		// 		message: 'Success',
		// 		data: [
		// 			{
		// 				severity: 'TOTAL',
		// 				alarmCount: 0,
		// 			},
		// 			{
		// 				severity: 'CRITICAL',
		// 				alarmCount: 0,
		// 			},
		// 			{
		// 				severity: 'MAJOR',
		// 				alarmCount: 0,
		// 			},
		// 			{
		// 				severity: 'MINOR',
		// 				alarmCount: 0,
		// 			},
		// 		],
		// 	},
		// 	status: 200,
		// };
    //console.log(searchHash === rmsStore.getState().alarmsReducer.alarmListCardsRequestSearchHash && isEqual(filterHash, rmsStore.getState().alarmsReducer.alarmListCardsRequestFilterHash))
      const action: Partial<AcAlarmsAction> = {
        type: acalarmTypes.FETCH_AC_ALARM_COUNT_DATA,
        alarmDashboardCount: response.data?.data,
      };
      dispatch(action);
    
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcAlarmsAction> = {
        type: acalarmTypes.SET_PULSE_AC_ALARM_LOADER,
        pulseAlarmLoader: false
      }
      dispatch(loaderEndAction);
    }

  } catch (error) {
    const loaderEndAction: Partial<AcAlarmsAction> = {
      type: acalarmTypes.SET_PULSE_AC_ALARM_LOADER,
      pulseAlarmLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
};


export const fetchAcAlarmEventListData: any =
  (reqParams) =>
    async (dispatch): Promise<void> => {
      try {
        const loaderStartAction: Partial<AcAlarmsAction> = {
          type: acalarmTypes.SET_PULSE_AC_ALARM_LIST_LOADER,
          alarmTableListLoader: true
        }
        dispatch(loaderStartAction);
        const searchHash = reqParams?.searchTerm
        const filterHash = reqParams?.filters
        const hashAction: Partial<AlarmsAction> = {
          type: acalarmTypes.SET_AC_ALARM_LIST_REQUEST_HASH,
          alarmListRequestSearchHash: searchHash,
          alarmListRequestFilterHash: filterHash
        }
        await dispatch(hashAction)
        const response = await hwAxios.post(url + '/alarm-event/list', reqParams);
        if (searchHash === rmsStore.getState().alarmsReducer.alarmListRequestSearchHash && isEqual(filterHash, rmsStore.getState().alarmsReducer.alarmListRequestFilterHash)) {
          const action = {
            type: acalarmTypes.FETCH_AC_ALARM_EVENT_DATA,
            alarmEvents: response.data?.data?.alarmEvents,
            alarmEventsCount: response.data?.data?.alarmEventsCount,
          };
          dispatch(action);
        }
        if (response?.status === 200) {
          const loaderEndAction: Partial<AcAlarmsAction> = {
            type: acalarmTypes.SET_PULSE_AC_ALARM_LIST_LOADER,
            alarmTableListLoader: false
          }
          dispatch(loaderEndAction);
        }
      } catch (error) {
        const loaderEndAction: Partial<AcAlarmsAction> = {
          type: acalarmTypes.SET_PULSE_AC_ALARM_LIST_LOADER,
          alarmTableListLoader: false
        }
        dispatch(loaderEndAction);
        console.error(error);
        throw error;
      }
    };


export const fetchAcAlarmEventCardCountData: any = (reqParams) => async (dispatch): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcAlarmsAction> = {
      type: acalarmTypes.SET_PULSE_AC_ALARM_LOADER,
      pulseAlarmLoader: true
    }
    dispatch(loaderStartAction);
    const searchHash = reqParams?.searchTerm
    const filterHash = reqParams?.filters
    const hashAction: Partial<AcAlarmsAction> = {
      type: acalarmTypes.SET_AC_ALARM_LIST_CARDS_REQUEST_HASH,
      alarmListCardsRequestSearchHash: searchHash,
      alarmListCardsRequestFilterHash: filterHash
    }
    await dispatch(hashAction)
    const response = await hwAxios.post(url + '/alarm-event/count', reqParams);
    if (searchHash === rmsStore.getState().alarmsReducer.alarmListCardsRequestSearchHash && isEqual(filterHash, rmsStore.getState().alarmsReducer.alarmListCardsRequestFilterHash)) {
      const action: Partial<AcAlarmsAction> = {
        type: acalarmTypes.FETCH_AC_ALARM_EVENT_COUNT_DATA,
        alarmEventCount: response.data?.data,
      };
      dispatch(action);
    }
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcAlarmsAction> = {
        type: acalarmTypes.SET_PULSE_AC_ALARM_LOADER,
        pulseAlarmLoader: false
      }
      dispatch(loaderEndAction);
    }

  } catch (error) {
    const loaderEndAction: Partial<AcAlarmsAction> = {
      type: acalarmTypes.SET_PULSE_AC_ALARM_LOADER,
      pulseAlarmLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
};

export const setAcAlarmTableProps: any = (data, fetchType) => async (dispatch: (arg0: Partial<AcAlarmsAction>) => void): Promise<void> => {
  if (fetchType === 'history') {
    // Partial<AlarmsAction>
    const action = {
      type: acalarmTypes.SET_AC_ALARM_HISTORY_TABLE_PROPS,
      alarmHistoryTableProps: data,
    };
    dispatch(action);
  } else if (fetchType === 'active') {
    // : Partial<AlarmsAction>
    const action = {
      type: acalarmTypes.SET_ACTIVE_AC_ALARM_TABLE_PROPS,
      activeAlarmTableProps: data,
    };
    dispatch(action);
  }

};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const exportAcAlarmHistoryData: any = (reqParams) => async (): Promise<unknown> => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data, status } = await hwAxios.post( url + '/alarm/export-csv', reqParams);
    return { data, status };
    // const action: Partial<AlarmsAction> = {
    //   type: acalarmTypes.EXPORT_ALARM_DATA,
    // };
    // dispatch(action);
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}

export const exportAcAlarmEventHistoryData: any = (reqParams) => async (): Promise<unknown> => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data, status } = await hwAxios.post(url + '/alarm-event/export', reqParams);
    return { data, status };
    // const action: Partial<AlarmsAction> = {
    //   type: acalarmTypes.EXPORT_ALARM_DATA,
    // };
    // dispatch(action);
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const setRedirectedStateForAcAlarmFilters = (data, severityId?: string | null, alarmType?: string, customerId?: string | null, chargerStatus?: string,onlyExternalCustomers?:any , alarmSetTimeStamp?: string[],chargerIds?: string[]) => async (dispatch) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const action = {
        type: acalarmTypes.SET_AC_FILTERS_APPLIED_FROM_REDIRECTION,
        alarmFiltersAppliedFromRedirection: data,
      };
      const dashboardSelectedChargerType = getAcFilterSelectedValue('chargerType', 'acdashboard', false)
      if (dashboardSelectedChargerType && data) {
        await setAcFilterData(dashboardSelectedChargerType, 'chargerType', 'acalarms', 'SET', false)(dispatch)
      }
      if (customerId) {
        if (!rmsStore.getState().referenceDataReducer?.customerReferenceData) {
          await dispatch(fetchCustomerReferenceData())
        }
        const customer = rmsStore.getState().referenceDataReducer?.customerReferenceData?.find(customer => customer?.id === customerId)
        if (customer) {
          await setAcFilterData(customer, 'customer', 'acalarms', 'SET', true)(dispatch);
        }
      }
      if (alarmType) {
        if (!rmsStore.getState().referenceDataReducer?.alarmTypeReferenceData) {
          await dispatch(fetchAlarmTypeReferenceData())
        }
        const alarmTypeToSelect = rmsStore.getState().referenceDataReducer?.alarmTypeReferenceData?.find(item => item?.label === alarmType)
        if (alarmTypeToSelect) {
          await setAcFilterData(alarmTypeToSelect, 'alarmType', 'acalarms', 'SET', false)(dispatch);
        }
      }
      if (severityId) {
        if (!rmsStore.getState().referenceDataReducer?.alarmSeverityReferenceData) {
          await dispatch(fetchAlarmRuleSeverityReferenceData())
        }
        const severity = rmsStore.getState().referenceDataReducer?.alarmSeverityReferenceData?.find(severity => severity?.id === severityId)
        if (severity) {
          await setAcFilterData(severity, 'severity', 'acalarms', 'SET', false)(dispatch);
        }
      }
      if (chargerStatus) {
        const chargerStatusReferenceDataVal = (rmsStore.getState().referenceDataReducer.chargerStatusReferenceData) ? rmsStore.getState().referenceDataReducer?.chargerStatusReferenceData : JSON.parse(await dispatch(fetchChargerStatusReferenceData()));
        const status = chargerStatusReferenceDataVal?.find(chargerStatusval => chargerStatusval?.id === chargerStatus);
        if (status) {
          await setAcFilterData(status, 'chargerStatus', 'acalarms', 'SET', false)(dispatch);
        }
      }
       if(onlyExternalCustomers){
          await setAcFilterData(onlyExternalCustomers, 'customer', 'acalarms', 'SET', true)(dispatch)
      }
      if(alarmSetTimeStamp){
        await setAcFilterData(alarmSetTimeStamp,'alarmSetTimeStamp','acalarms', 'SET', false)(dispatch)
      }
if (chargerIds && chargerIds.length > 0) {
  const chargerRef = (rmsStore.getState().referenceDataReducer?.chargerVisibleIdReferenceData ) ? rmsStore.getState().referenceDataReducer?.chargerVisibleIdReferenceData  :  JSON.parse(await dispatch(fetchChargerVisibleIdReferenceData()));

  if (chargerRef) {
    const matchedChargers = chargerRef.filter(item =>
      chargerIds.includes(item?.id)
    );

    if (matchedChargers.length > 0) {
      await setAcFilterData(
        matchedChargers,
        'chargerId',
        'acalarms',
        'SET',
        false
      )(dispatch);
    }
  }
}
      await dispatch(action);
      // Resolve the promise
      resolve('Action dispatched successfully');
    } catch (error) {
      // Reject the promise with the error
      reject(error);
    }
  });
};

export const saveAcNotes: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwAxios.put(url + '/alarm', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}
